
import { AppLanguage } from '../types';

export const translations = {
  en: {
    sidebar: {
      home: 'Home',
      chat: 'Zomi Generative AI',
      dictionary: 'Zomi Dictionary',
      translate: 'Zomi Translate',
      image: 'Zomi Art',
      video: 'Zomi Video',
      audio: 'Zomi Audio',
      search: 'Zomi Search',
      maps: 'Zomi Maps',
      subscription: 'Subscription',
      upgrade: 'Upgrade Plan',
      unlimited: 'Unlimited Access',
      creditsLeft: 'Credits Left',
      freePlan: 'Free Plan',
      signIn: 'Log In',
      signOut: 'Log Out',
      profile: 'Settings',
      about: 'About Zomi Generative AI',
      editProfile: 'Settings',
      persona: 'AI Personality',
      professional: 'Professional',
      friendly: 'Friendly',
      creative: 'Creative',
      concise: 'Concise'
    },
    search: {
      title: 'Real-time Grounded Search',
      sub: 'Search the live web with AI analysis and direct citations.',
      placeholder: 'Search for recent events...',
      button: 'Search',
      searching: 'Searching',
      analysis: 'Search Analysis',
      sources: 'Sources & Citations',
      accessing: 'Accessing Real-time Web',
      suggestions: [
        { text: 'Current stock market trends' },
        { text: 'Latest global tech news' },
        { text: 'Best AI tools of 2025' },
        { text: 'Current price of Bitcoin' }
      ]
    },
    profile: {
      title: 'Settings',
      sub: 'Manage your Zomi Generative AI account and preferences.',
      username: 'Name',
      email: 'Email',
      language: 'Interface Language',
      save: 'Save',
      saving: 'Saving...',
      success: 'Settings Updated!',
      personalInfo: 'Account',
      preferences: 'Preferences'
    },
    auth: {
      signInTitle: 'Welcome Back',
      signUpTitle: 'Create Account',
      forgotTitle: 'Reset Password',
      signInSub: 'Log in with your ZomiGenAI account to continue.',
      signUpSub: 'Start your journey with ZomiGenAI.',
      forgotSub: 'Enter your email to receive a password reset link.',
      email: 'Email Address',
      password: 'Password',
      username: 'Full Name',
      signInBtn: 'Continue',
      signUpBtn: 'Continue',
      resetBtn: 'Send Reset Link',
      noAccount: "Don't have an account?",
      hasAccount: 'Already have an account?',
      forgotLink: 'Forgot password?',
      backToLogin: 'Back to Log In',
      switchSignUp: 'Sign Up',
      switchSignIn: 'Log In',
      success: 'Success!',
      resetSuccess: 'Reset link sent to your email!',
      or: 'or',
      continueWithGoogle: 'Continue with Google',
      continueWithGithub: 'Continue with GitHub',
      continueWithFacebook: 'Continue with Facebook',
      continueWithApple: 'Continue with Apple'
    },
    home: {
      hero: 'Zomi Generative AI',
      sub: 'The specialized AI for the Zomi community. Bridging heritage and high-tech innovation.',
      lexicon: 'Zomi Dictionary',
      lexiconSub: 'Academic Zomi & English Dictionary.',
      translation: 'Zomi Translate',
      translationSub: 'Context-aware multilingual bridge.',
      chat: 'Zomi Generative AI',
      chatSub: 'Advanced reasoning and file analysis.',
      image: 'Zomi Art',
      imageSub: 'High-fidelity generative art.',
      proCta: 'Upgrade to Pro',
      mission: 'Our Mission',
      missionSub: 'Empowering Zomi people through digital sovereignty and indigenous AI development.',
      roadmap: 'Timeline 2025',
      roadmapSub: 'Our vision for the future of Zomi technology.'
    },
    chat: {
      greeting: 'How can I help you today?',
      placeholder: 'Message ZomiGenAI...',
      placeholderPro: 'Message ZomiGenAI Pro...',
      proActive: 'Pro Engine',
      inaccurate: 'Zomi Generative AI can make mistakes. Check important info.'
    },
    dictionary: {
      title: 'Zomi Dictionary',
      sub: 'Zomi and English Academic Lexicon.',
      placeholder: 'Type a word...',
      define: 'Define',
      scanning: 'Searching...',
      start: 'Look up Zomi or English terms.'
    },
    translate: {
      title: 'Zomi Translate',
      sub: 'Translate between Zomi and world languages.',
      placeholder: 'Enter text...',
      button: 'Translate',
      translating: 'Translating...'
    },
    paywall: {
      title: 'Credit Limit Reached',
      sub: 'You have exhausted your free credits for today.',
      cta: 'Get ZomiGenAI Pro',
      back: 'Back to Home'
    }
  },
  zo: {
    sidebar: {
      home: 'Innpi',
      chat: 'Zomi Generative AI',
      dictionary: 'Dictionary',
      translate: 'Lailetna',
      image: 'Gam Lim',
      video: 'Video',
      audio: 'Aw',
      search: 'Zon\'na',
      maps: 'Mun',
      subscription: 'Mihon\'na',
      upgrade: 'Pro ah hih-thak in',
      unlimited: 'Hun ciangtan omlau',
      creditsLeft: 'Omlai',
      freePlan: 'Amawkna',
      signIn: 'Lutna',
      signOut: 'Pusuahna',
      profile: 'Kei-min',
      about: 'Kicianna',
      editProfile: 'Settings',
      persona: 'AI Hih-na',
      professional: 'Kician Tak',
      friendly: 'Lawi-tah',
      creative: 'Gual-ziam',
      concise: 'Tawk-tom'
    },
    search: {
      title: 'Gamtumpuam Thu Zon\'na',
      sub: 'AI tawh kician takin internet sunga thuthak te zon\'na.',
      placeholder: 'Tulaitak thupiang te zong in...',
      button: 'Zong In',
      searching: 'Zong Laitak',
      analysis: 'Zon\'na Suutna',
      sources: 'Mun-atna leh Bulphuh te',
      accessing: 'Internet thuthak te ka zong laitak',
      suggestions: [
        { text: 'Stock market tulaitak dinmun' },
        { text: 'Gamtumpuam tech thuthak' },
        { text: '2025 sunga AI vanzat hoihpente' },
        { text: 'Bitcoin tulaitak man' }
      ]
    },
    profile: {
      title: 'Settings',
      sub: 'Zomi Generative AI ah na deihna te khek thei hi.',
      username: 'Na Min',
      email: 'Email At-na',
      language: 'Pau Deihna',
      save: 'Khia In',
      saving: 'Khia Laitak...',
      success: 'Profile Khek Khia Khin Hi!',
      personalInfo: 'Account',
      preferences: 'Deihna Tuamtuam'
    },
    auth: {
      signInTitle: 'Kong Vaidawn Uh Hi',
      signUpTitle: 'Min Thuna',
      forgotTitle: 'Email Khekna',
      signInSub: 'ZomiGenAI na zatzat nadingin lut in.',
      signUpSub: 'ZomiGenAI ah lut inla bawlkhia in.',
      forgotSub: 'Na email at inla, thukihualna khekna laikhia in.',
      email: 'Email At-na',
      password: 'Email Thukihualna',
      username: 'Na Min',
      signInBtn: 'Lut In',
      signUpBtn: 'Min Thun In',
      resetBtn: 'Khia In',
      noAccount: "Account na nei nai hiam?",
      hasAccount: 'Account na nei khin hiam?',
      forgotLink: 'Password na mangngilh hiam?',
      backToLogin: 'Lutna ah kileh in',
      switchSignUp: 'Thun In',
      switchSignIn: 'Lut In',
      success: 'Lut Khin!',
      resetSuccess: 'Email ah thukihualna khekna khia khin hi!',
      or: 'ahikeileh',
      continueWithGoogle: 'Google Tawh Zom In',
      continueWithGithub: 'GitHub Tawh Zom In',
      continueWithFacebook: 'Facebook Tawh Zom In',
      continueWithApple: 'Apple Tawh Zom In'
    },
    home: {
      hero: 'Zomi Generative AI',
      sub: 'Zomi community te adingin AI thiamna tawh pilna zon\'na leh digital siamna munpi ahi hi.',
      lexicon: 'Dictionary',
      lexiconSub: 'Zomi leh English dictionary kician.',
      translation: 'Letna',
      translationSub: 'Pau tuamtuam manlang takin letna.',
      chat: 'Zomi Generative AI',
      chatSub: 'Pau tuamtuam leh lai-at siamna.',
      image: 'Lim-bawl',
      imageSub: 'La-at tawh gamlim bawlna siam.',
      proCta: 'Pro ah Thun In',
      mission: 'Zomi Generative AI Hih-na?',
      missionSub: 'Zomi community te ading AI thiamna tawh mabaan bawlna.',
      roadmap: 'Mabaan 2025',
      roadmapSub: 'Zomi technology lam-ah thupi takin mabaan zuihna.'
    },
    chat: {
      greeting: 'Bang Huhna Deih Na Hi Hiam?',
      placeholder: 'ZomiGenAI tungah dong in...',
      placeholderPro: 'ZomiGenAI Pro tungah dong in...',
      proActive: 'Pro Engine Active',
      inaccurate: 'Zomi Generative AI in kicin-lohna a om thei hi.'
    },
    dictionary: {
      title: 'Dictionary',
      sub: 'Zomi leh English kammal zon\'na kician.',
      placeholder: 'Kammal khat-at in...',
      define: 'Define',
      scanning: 'Kammal te ka zong laitak...',
      start: 'Kammal khat-at in la, a hih-na en in.'
    },
    translate: {
      title: 'Lailetna',
      sub: 'AI siamna tawh Zomi pau letna munpi.',
      placeholder: 'La-at in...',
      button: 'Translate Now',
      translating: 'Kamletna ka bawl laitak...'
    },
    paywall: {
      title: 'Ciangtan Na Bei Hi!',
      sub: 'Tu ni ading free credits na zang khin hi.',
      cta: 'Pro Plans En In',
      back: 'Innpi Ah Kileh In'
    }
  },
  my: {
    sidebar: {
      home: 'ပင်မစာမျက်နှာ',
      chat: 'Zomi Generative AI',
      dictionary: 'အဘိဓာန်',
      translate: 'ဘာသာပြန်',
      image: 'ပုံရိပ်များ',
      video: 'ဗီဒီယို',
      audio: 'အသံ',
      search: 'ရှာဖွေမှု',
      maps: 'မြေပုံ',
      subscription: 'စာရင်းသွင်းမှု',
      upgrade: 'Pro သို့ အဆင့်မြှင့်ပါ',
      unlimited: 'အကန့်အသတ်မဲ့',
      creditsLeft: 'ကျန်ရှိသည်',
      freePlan: 'အခမဲ့ အစီအစဉ်',
      signIn: 'အကောင့်ဝင်ရန်',
      signOut: 'ထွက်ရန်',
      profile: 'ဆက်တင်များ',
      about: 'Zomi Generative AI အကြောင်း',
      editProfile: 'ဆက်တင်များ',
      persona: 'AI စရိုက်',
      professional: 'ကျွမ်းကျင်သော',
      friendly: 'ရင်းနှီးသော',
      creative: 'ဖန်တီးနိုင်သော',
      concise: 'တိုတိုနှင့်လိုရင်း'
    },
    search: {
      title: 'အချိန်နှင့်တပြေးညီ ရှာဖွေမှု',
      sub: 'AI ခွဲခြမ်းစိတ်ဖြာမှုနှင့်အတူ ဝဘ်ပေါ်တွင် တိုက်ရိုက်ရှာဖွေပါ။',
      placeholder: 'လတ်တလောဖြစ်ရပ်များကို ရှာဖွေပါ...',
      button: 'ရှာမည်',
      searching: 'ရှာနေသည်',
      analysis: 'ရှာဖွေမှု ခွဲခြမ်းစိတ်ဖြာချက်',
      sources: 'ရင်းမြစ်များ',
      accessing: 'ဝဘ်ပေါ်တွင် ရှာဖွေနေပါသည်',
      suggestions: [
        { text: 'လက်ရှိ စတော့ဈေးကွက် အခြေအနေ' },
        { text: 'နောက်ဆုံးပေါ် နည်းပညာသတင်းများ' },
        { text: '၂၀၂၅ ခုနှစ်အတွက် အကောင်းဆုံး AI ကိရိယာများ' },
        { text: 'လက်ရှိ Bitcoin ဈေးနှုန်း' }
      ]
    },
    profile: {
      title: 'ဆက်တင်များ',
      sub: 'Zomi Generative AI ပရိုဖိုင်ကို စီမံပါ။',
      username: 'အမည်',
      email: 'အီးမေးလ်',
      language: 'ဘာသာစကား',
      save: 'သိမ်းဆည်းမည်',
      saving: 'သိမ်းဆည်းနေပါသည်...',
      success: 'ပြင်ဆင်ပြီးပါပြီ။',
      personalInfo: 'ကိုယ်ရေးအချက်အလက်',
      preferences: 'စိတ်ကြိုက်ရွေးချယ်မှုများ'
    },
    auth: {
      signInTitle: 'ပြန်လည်ကြိုဆိုပါသည်',
      signUpTitle: 'အကောင့်ဖွင့်ရန်',
      forgotTitle: 'လျှို့ဝှက်နံပါတ် ပြန်လည်သတ်မှတ်ရန်',
      signInSub: 'ZomiGenAI ကို အသုံးပြုရန် အကောင့်ဝင်ပါ။',
      signUpSub: 'ZomiGenAI သို့ ဝင်ရောက်ပြီး ဖန်တီးပါ။',
      forgotSub: 'လျှို့ဝှက်နံပါတ် ပြန်လည်သတ်မှတ်ရန် အီးမေးလ် ရိုက်ထည့်ပါ။',
      email: 'အီးမေးလ်',
      password: 'လျှို့ဝှက်နံပါတ်',
      username: 'အမည်',
      signInBtn: 'ဝင်မည်',
      signUpBtn: 'အကောင့်ဖွင့်မည်',
      resetBtn: 'ပို့မည်',
      noAccount: "အကောင့်မရှိသေးဘူးလား?",
      hasAccount: 'အကောင့်ရှိပြီးသားလား?',
      forgotLink: 'လျှို့ဝှက်နံပါတ် မေ့နေပါသလား?',
      backToLogin: 'အကောင့်ဝင်ခြင်းသို့ ပြန်သွားရန်',
      switchSignUp: 'ဖွင့်ရန်',
      switchSignIn: 'ဝင်ရန်',
      success: 'အောင်မြင်ပါသည်!',
      resetSuccess: 'လျှို့ဝှက်နံပါတ် ပြန်လည်သတ်မှတ်ရန် လင့်ခ်ကို အီးမေးလ်သို့ ပို့လိုက်ပါပြီ။',
      or: 'သို့မဟုတ်',
      continueWithGoogle: 'Google ဖြင့် ဆက်လက်လုပ်ဆောင်ပါ',
      continueWithGithub: 'GitHub ဖြင့် ဆက်လက်လုပ်ဆောင်ပါ',
      continueWithFacebook: 'Facebook ဖြင့် ဆက်လက်လုပ်ဆောင်ပါ',
      continueWithApple: 'Apple ဖြင့် ဆက်လက်လုပ်ဆောင်ပါ'
    },
    home: {
      hero: 'Zomi Generative AI',
      sub: 'အဆင့်မြင့် ဉာဏ်ရည်တုနည်းပညာဖြင့် ဇိုမီးလူငယ်များကို စွမ်းဆောင်ရည်မြှင့်တင်ပေးခြင်း။',
      lexicon: 'ဝေါဟာရ',
      lexiconSub: 'ပြည့်စုံသော ဇိုမီးနှင့် အင်္ဂလိပ် အဘိဓာန်။',
      translation: 'ဘာသာပြန်ခြင်း',
      translationSub: 'မြန်ဆန်တိကျသော ဘာသာစကားကူးပြောင်းမှု။',
      chat: 'Zomi Generative AI',
      chatSub: 'ဉာဏ်ရည်ထက်မြက်သော ခွဲခြမ်းစိတ်ဖြာမှု။',
      image: 'အနုပညာစတူဒီယို',
      imageSub: 'စာသားမှ 4K ပုံရိပ်များ ဖန်တီးပါ။',
      proCta: 'Pro သို့ အဆင့်မြှင့်ပါ',
      mission: 'Zomi Generative AI ဆိုတာဘာလဲ?',
      missionSub: 'ဇိုမီးလူမျိုးများအတွက် နည်းပညာစွမ်းအားမြှင့်တင်ရေး အစပြုမှု။',
      roadmap: 'ရှေ့လုပ်ငန်းစဉ် ၂၀၂၅',
      roadmapSub: 'ယဉ်ကျေးမှုထိန်းသိမ်းရေးနှင့် နည်းပညာတိုးတက်ရေးခရီး။'
    },
    chat: {
      greeting: 'ဘာများ ကူညီပေးရမလဲ?',
      placeholder: 'ZomiGenAI ထံ မေးမြန်းပါ...',
      placeholderPro: 'ZomiGenAI Pro ထံ မေးမြန်းပါ...',
      proActive: 'Pro စနစ်',
      inaccurate: 'Zomi Generative AI သည် မှားယွင်းနိုင်သည်ကို သတိပြုပါ။'
    },
    dictionary: {
      title: 'ဇိုမီး အဘိဓာန်',
      sub: 'ဇိုမီးနှင့် အင်္ဂလိပ် ဘာသာစကား အဆင့်မြင့်အဘိဓာန်။',
      placeholder: 'စကားလုံး ရိုက်ထည့်ပါ...',
      define: 'အဓိပ္ပာယ်',
      scanning: 'ရှာဖွေနေပါသည်...',
      start: 'စကားလုံးတစ်ခု ရိုက်ထည့်ပြီး အဓိပ္ပာယ်ကို ကြည့်ပါ။'
    },
    translate: {
      title: 'ဘာသာစကားမျိုးစုံ ဘာသာပြန်',
      sub: 'AI ဖြင့် ဘာသာစကားများကို ဆက်သွယ်ပေးခြင်း။',
      placeholder: 'စာသားရိုက်ပါ...',
      button: 'ဘာသာပြန်မည်',
      translating: 'ဘာသာပြန်နေပါသည်...'
    },
    paywall: {
      title: 'အသုံးပြုမှု ကုန်ဆုံးပါပြီ!',
      sub: 'ယနေ့အတွက် အခမဲ့အသုံးပြုခွင့် ကုန်ဆုံးသွားပါပြီ။',
      cta: 'Pro အစီအစဉ်များ ကြည့်မည်',
      back: 'ပင်မစာမျက်နှာသို့'
    }
  }
};
